import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function Cart({ cart, removeFromCart, handleCheckout, isError }) {
  const { t } = useTranslation();
  const total = cart.reduce((acc, item) => acc + item.price * item.quantity, 0);

  if (isError) {
    return <p className="error">{t('error_message')}</p>;
  }

  return (
    <aside className="cart">
      <h2>{t('shopping_cart')}</h2>
      {cart.length === 0 && <p className="empty-cart">{t('empty_cart')}</p>}
      {cart.map(item => (
        <div key={item.id} className="cart-item">
          <img src={item.image} alt={item.name} className="cart-item-image" />
          <div className="cart-item-details">
            <h3>{item.name}</h3>
            <p>{t('quantity')}: {item.quantity}</p>
            <p>{t('currency', { price: (item.price * item.quantity).toFixed(2) })}</p>
          </div>
          <button onClick={() => removeFromCart(item.id)} className="remove-btn">{t('remove')}</button>
        </div>
      ))}
      {cart.length > 0 && (
        <div className="cart-summary">
          <h3>{t('total')}: {t('currency', { price: total.toFixed(2) })}</h3>
          <Link to="/checkout" className="checkout-btn">{t('proceed_to_checkout')}</Link>
        </div>
      )}
    </aside>
  );
}

Cart.propTypes = {
  cart: PropTypes.array.isRequired,
  removeFromCart: PropTypes.func.isRequired,
  handleCheckout: PropTypes.func.isRequired,
  isError: PropTypes.bool.isRequired,
};

export default Cart;
